import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";
import { setInvoiceTableRowTestId } from "../../../invoice-table.utils";

export const InvoiceIdCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const invoiceId = props.getValue() as string;
  return (
    <div data-testid={setInvoiceTableRowTestId(invoiceId)} className="font-medium">
      {invoiceId}
    </div>
  );
};
